export enum ShareFlow {
  Credit = 1,
  Debit = 2,
}
